// 个人校验规则
const personalRules = {
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  identityNo: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.identityNo'),
      trigger: ['blur', 'change'],
    },
  ],
  province: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.province'),
      trigger: ['blur', 'change'],
    },
  ],
  city: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.city'),
      trigger: ['blur', 'change'],
    },
  ],
  streetAddress: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.streetAddress'),
      trigger: ['blur', 'change'],
    },
  ],
  roomNo: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.roomNo'),
      trigger: ['blur', 'change'],
    },
  ],
};
// 国内企业
const domesticEnterprisesRules = {
  // 顶部
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  creditCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.creditCode'),
      trigger: ['blur', 'change'],
    },
  ],
  invoiceAddress: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoiceAddress'),
      trigger: ['blur', 'change'],
    },
  ],
  invoicePhone: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoicePhone'),
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoiceBankName'),
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankAccount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'),
      trigger: ['blur', 'change'],
    },
  ],
  legalPerson: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.legalPerson'),
      trigger: ['blur', 'change'],
    },
  ],
  registeredAssets: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.registeredAssets'),
      trigger: ['blur', 'change'],
    },
  ],
  currencyType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  establishedDate: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.establishedDate'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  personnelIdentificationNumber: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.personnelIdentificationNumber'),
      trigger: ['blur', 'change'],
    },
  ],
  // tradeCurrency: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.tradeCurrency'), trigger: ["blur", "change"] },
  // ],
  enterpriseType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.enterpriseType'),
      trigger: ['blur', 'change'],
    },
  ],
  // taxType: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.taxType'), trigger: ["blur", "change"] },
  // ],
  // postCode: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.postCode'), trigger: ["blur", "change"] },
  // ],
  // province: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.province'), trigger: ["blur", "change"] },
  // ],
  // city: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.city'), trigger: ["blur", "change"] },
  // ],
  // streetAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.streetAddress'), trigger: ["blur", "change"] },
  // ],
  // roomNo: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.roomNo'), trigger: ["blur", "change"] },
  // ],
  // 销售数据
  sellAccountGroup: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.sellAccountGroup'),
      trigger: ['blur', 'change'],
    },
  ],
  // 采购数据
  procurementAccountGroup: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.procurementAccountGroup'),
      trigger: ['blur', 'change'],
    },
  ],
};
// 国外企业
const foreignEnterprisesRules = {
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
};
// topForm
const topDataRules = {
  supplierName: [
    {
      required: true,
      message: window.vm.$t('supplyChain.placeholder.supplierName'),
      trigger: ['blur', 'change'],
    },
  ],
};

export { personalRules, domesticEnterprisesRules, foreignEnterprisesRules, topDataRules };
